export const SET_APP_VERSION = 'mapReducer/SET_GAP_FILTER' as const;

export const setAppVersion = (payload: string) => ({
  type: SET_APP_VERSION,
  payload,
});

type StorageActions = ReturnType<typeof setAppVersion>;

export type StorageState = {
  appVersion: string;
};

const initialState: StorageState = {
  appVersion: '2.52.0',
};

export default function appReducer(
  state: StorageState = initialState,
  action: StorageActions,
): StorageState {
  switch (action.type) {
    case SET_APP_VERSION:
      return { ...state, appVersion: action.payload };
    default:
      return state;
  }
}
